<template>
  <div>
    <div class='goods_list_box'>
  <div class='load_details'>
    该商品的其他优惠券
  </div>
  <div class='goods_list' v-for="(item,index) in otherCoupon" :key="item.id" v-if="activityID!=item.activityID" ><!---->
    <div class='goods_list_content'>
      <div class='goods_list_pic_contant'>
        <img :src="item.goodsPic" class="goods_list_pic"></image>
      </div>
      <div class='goods_list_content_wrapper'>
        <div class='googs_content_title'>{{item.goodsName}}</div>
        <div class='shop_name'>
          <!-- <img src="../../images/tmallSelected.png" class='tm_icon'>
          <img src="../../images/taobao.png"  class='tm_icon'>
          <img src="../../images/haitao.png" class='tm_icon'>
          <img src="../../images/juhuasuan.png" class='tm_icon'>
          <img src="../../images/taoqianggou.png"  class='tm_icon'>
          <img src="../../images/video.png" class='tm_icon'> -->
          <img src="../../images/tmallSelected.png"   v-if="item.mallType=='天猫'" class='tm_icon'/>
          <img src="../../images/taobao.png" v-if="item.mallType!='天猫'" class='tm_icon'/>
          <img src="../../images/haitao.png" v-if="item.isHaiTao==1" class='tm_icon'/>
          <img src="../../images/juhuasuan.png"  v-if="item.isJuHuaSuan==1" class='tm_icon'/>
          <img src="../../images/taoqianggou.png" v-if="item.isTaoQiangGou==1" class='tm_icon'/>
          <img src="../../images/video.png" v-if="item.isVideo==1" class='tm_icon'/>
          {{item.shopName}}</div>
        <div class='goods_des'>
          <div class='qh'>券后:<span class="color_red">￥</span><span class="qh_money">{{item.finalPrice}}</span></div>
          <div class='price'>原价￥{{item.price}}</div>
        </div>
      </div>
    </div>
    <router-link :to="{ name: 'item', params: { id: item.id }}" class='goods_list_price'>
      <!--圆圈-->
      <div class="circle_wrapper">
        <div class="circle1"></div>
        <div class="circle2"></div>
      </div>
      <div class='get_q_conut'>
        <span class='get_q_conut1'>￥</span>
        <span class='get_q_conut2'>{{item.money}}</span>
      </div>
      <div class='get_q'>
        <span>去领券</span>
      </div>
    </router-link>
  </div>
</div>
  </div>
</template>
<script type = "text/ecamscript-6">
  export default {
    name:"otherCoupon",
    props:['goodsID','activityID'],
    data(){
      return{
        otherCoupon:[]
      }
    },
    created (){
      this.login()
    },
    methods:{
      /*axios调用数据*/
       login () {
         this.url = "api/getGoodsByID.php?goodsID="+this.goodsID
         console.log(this.url )
         this.$ajax.autoService
             .login(this.url)
             .then((res) => {
               this.otherCoupon = this.otherCoupon.concat(res.data.map(function(item){
               var temp = item.goodsPic    //有些图片没有http头
               temp = temp.replace('https:', '')
               temp = temp.replace('http:', '')
               item.money = parseInt(item.money)
               item.goodsPic = "http:" + temp
               item.goodsName = item.goodsName.slice(0,20)
               item.finalPrice = (item.price - item.money).toFixed(2)
                 return item
               }))
               //this.loading = false

               console.log(this.otherCoupon)
             }, (res) => {
                 console.log("error")
                 this.REQUIRE = true;
             })
        },
    }
  }
</script>
<style lang="stylus">
  .goods_list_box
    padding: 5px 20px 0
    .load_details
      width: 695px
      margin: 0 auto
      height: 90px
      line-height: 90px
      font-size: 28px
      color: #666
    .goods_list
      width: 100%
      display: flex
      margin-bottom:20px
      .goods_list_content
        width: 525px
        flex: 0 0 525px
        height: 182px
        border-radius: 20px 0 0 20px
        background: #fff
        display: flex
        padding: 20px
        box-sizing: border-box
        .goods_list_pic_contant,.goods_list_pic
          width: 145px
          height: 145px
      .goods_list_content_wrapper
        width: 360px
        height: 145px
        display: flex
        flex-direction: column
        justify-content: space-between
        padding-left: 20px
        box-sizing: border-box
        .googs_content_title
          font-size: 28px
          line-height: 36px
          color: #333
          overflow: hidden
        .shop_name
          font-size: 22px
          color: #999
          line-height: 20px
          .tm_icon
            width:20px
            height:20px
            vertical-align:middle
        .goods_des
          display: flex
          margin-top: 5px
          line-height: 28px
          .qh
            font-size:22px
            color:#333
            .color_red
              color:#ff4400
            .qh_money
              color:#ff4400
              font-size:30px
          .price
            font-size:22px
            color:#999
            text-decoration:line-through
            margin-left:20px
      .goods_list_price
        width: 185px
        height: 182px
        flex: 0 0 185px
        position: relative
        background:linear-gradient(to right,#f80,#f40)
        border-radius:0 20px 20px 0
        .circle_wrapper
          height: 182px
          position:absolute
          left:0px
          top:0px
          .circle1,.circle2
            width:22px
            height:8px
            position:absolute
            left:-11px
            background:#f2f2f2
          .circle1
            top:0px
            border-radius:0 0 11px 11px
          .circle2
            bottom:0px
            border-radius:11px 11px  0 0
        .get_q_conut
          width: 100%
          position: absolute
          left: 0px
          top: 40px
          color: #fff
          text-align: center
          .get_q_conut1
            font-size:24px
          .get_q_conut2
            font-size:48px
        .get_q
          width: 100%
          position: absolute
          left: 10px
          bottom: 40px
          color: #fff
          text-align: center
          font-size: 24px


</style>



// WEBPACK FOOTER //
// src/components/item/otherCoupon.vue